export default "__VITE_ASSET__r7ZjpIKO__"